/**
 * @file src/pages/client-management/logic/stats.js
 * @description Pure math for Client Management page summary stats.
 *
 * No React, no state, no side effects. Easy to unit test.
 */

/**
 * Count clients whose status is anything other than "inactive".
 * Treats undefined / null status as active (defensive default).
 *
 * @param {Array<{ status?: string }>} clients
 * @returns {number}
 */
export const countActive = (clients) =>
  clients.filter((c) => c.status !== "inactive").length;

/**
 * Count clients whose balanceType matches the given direction.
 *   "owes_you" → clients who owe the company
 *   "you_owe"  → clients the company owes
 *
 * @param {Array<{ balanceType?: string }>} clients
 * @param {"owes_you" | "you_owe"} direction
 * @returns {number}
 */
export const countByBalanceType = (clients, direction) =>
  clients.filter((c) => c.balanceType === direction).length;
